const topics = [
  { title: '热门电影', desc: '院线大片 · 经典回顾 · 高分精选', icon: 'ri-film-line', count: '2.3万部' },
  { title: '热播剧集', desc: '国产剧 · 韩剧 · 美剧 · 日剧', icon: 'ri-tv-2-line', count: '1.8万部' },
  { title: '综艺娱乐', desc: '真人秀 · 脱口秀 · 音乐竞演', icon: 'ri-emotion-laugh-line', count: '5600+期' },
  { title: '动漫番剧', desc: '日漫 · 国漫 · 欧美动画', icon: 'ri-rocket-line', count: '8900+部' },
  { title: '纪录片', desc: '自然 · 历史 · 科技 · 人文', icon: 'ri-earth-line', count: '3200+部' },
  { title: '动作冒险', desc: '热血打斗 · 极限追逐 · 超级英雄', icon: 'ri-fire-line', count: '热播中' },
  { title: '悬疑推理', desc: '烧脑剧情 · 反转结局 · 侦探故事', icon: 'ri-search-eye-line', count: '高分推荐' },
  { title: '喜剧搞笑', desc: '轻松一刻 · 爆笑合集 · 治愈日常', icon: 'ri-emotion-happy-line', count: '人气飙升' },
  { title: '少儿专区', desc: '益智动画 · 亲子共赏 · 成长故事', icon: 'ri-heart-line', count: '家长推荐' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-white">
      <div className="mx-auto max-w-screen-2xl px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            影视专题索引
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            九大分类专区，快速找到你想看的内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {topics.map((t) => (
            <a
              key={t.title}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex items-start gap-4 p-5 rounded-xl bg-background-50 border border-secondary-100 hover:border-primary-200 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <div className="flex-shrink-0 w-11 h-11 rounded-xl bg-primary-100 flex items-center justify-center">
                <i className={`${t.icon} text-primary-600 text-xl`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-heading text-base font-semibold text-foreground-900 whitespace-nowrap">{t.title}</h3>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">{t.count}</span>
                </div>
                <p className="text-xs md:text-sm text-foreground-500">{t.desc}</p>
              </div>
              <div className="flex-shrink-0 flex items-center h-full pt-1">
                <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors text-lg"></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}